(() => {
  const normalize = (value) => (value || '')
    .toLocaleLowerCase('es-CL')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const initFaq = (root) => {
    if (!root || root.dataset.anfFaqReady === 'true') return;
    root.dataset.anfFaqReady = 'true';

    const input = root.querySelector('[data-anf-faq-search]');
    const filters = Array.from(root.querySelectorAll('[data-anf-faq-filter]'));
    const items = Array.from(root.querySelectorAll('[data-anf-faq-item]'));
    const empty = root.querySelector('[data-anf-faq-empty]');
    const status = root.querySelector('[data-anf-faq-status]');
    let activeCategory = 'all';

    const apply = () => {
      const query = normalize(input ? input.value : '');
      let visible = 0;

      items.forEach((item) => {
        const matchesCategory = activeCategory === 'all' || item.dataset.category === activeCategory;
        const matchesQuery = !query || normalize(item.textContent).includes(query);
        const show = matchesCategory && matchesQuery;
        item.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (status) status.textContent = `${visible} ${visible === 1 ? 'respuesta' : 'respuestas'}`;
    };

    if (input) input.addEventListener('input', apply);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.anfFaqFilter || 'all';
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
        apply();
      });
    });

    apply();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-anf-faq]').forEach(initFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
